export default __webpack_public_path__ + "static/media/connect4.bb4bc00f.png";